import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject, catchError, map, of, tap } from 'rxjs';
import { APIResponse } from '../../shared/models/apiResponse';
import { Buyer, Lov, LovReq, Phase, ReqFields as ReqFields, Supplier, Filtration, Brand, Department, Category, SubCategory, Webshop, Labels, Pod, Subpod, Pagination, ErrorWarningType } from '../models/filter';
import { promotionConstants } from '../../shared/ocado-constants';
import { ActionNames, ErrorMsg, SupplierColumnValues } from '../models/gridData';
import { Proposal } from '../models/proposal';
import { environment } from '../../../environments/environment';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';
import { OcadoAuthService } from '../../shared/service/auth.service';
import { FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import { FilterValidators } from '../filter-validators';
import { FilterFormGroup, filtrationFormGroup, PaginationFormGroup, SortFormGroup } from '../models/filterFormGroup';
import { Filter, Sort } from '../models/filter';
import { SharedService } from '../../shared/service/shared.service';
import { Router } from '@angular/router';
import { SummaryV2Service } from './summary-v2.service';
import { PromotionV2Mapper } from '../../shared/models/promotions-v2/promotion-v2.mapper';
import { ProposalV2Mapper } from '../../shared/models/promotions-v2/proposal-v2.mapper';
import {
  PROPOSAL_ACTION,
  ProposalAction,
  PROMOTION_ACTION,
  PromotionAction,
} from '../../shared/models/promotions-v2/workflow-action.model';
@Injectable({
  providedIn: 'root'
})
export class SummaryService extends Subject<DataStateChangeEventArgs> {
  summaryGridHeaders!: BehaviorSubject<any[]>;
  reorderCols!: BehaviorSubject<any[]>;
  public masterDataBaseUrl = '';
  public promotionBaseUrl = '';
  public productBaseUrl = '';
  public workFlowBaseUrl = '';
  public dashboardBaseUrl = '';
  public supplierBaseUrl = '';
  public authBaseUrl = '';
  public proposalBaseUrl = '';
  public uploadDownloadBaseUrl = '';
  public hideDialog = new BehaviorSubject<boolean>(false);
  public columnResize = new BehaviorSubject<boolean>(true);
  public hideFilterDialog = new BehaviorSubject<boolean>(false);
  public gridFilterComponentBh = new BehaviorSubject<boolean>(false);
  public tooltipBh = new BehaviorSubject<boolean>(true);
  private promotionData!: BehaviorSubject<any>;
  private fieldsList!: BehaviorSubject<Lov[]>;
  private statusList!: BehaviorSubject<Lov[]>;
  private reqCatList!: BehaviorSubject<Lov[]>;
  private srcList!: BehaviorSubject<Lov[]>;
  private promoStatusList!: BehaviorSubject<Lov[]>;
  private cgRequestByList!: BehaviorSubject<Lov[]>;
  private criteriaList!: BehaviorSubject<Lov[]>;
  private cgRequestStatusList!: BehaviorSubject<Lov[]>;
  private sfmStatusList!: BehaviorSubject<Lov[]>;
  private promotionTypeList!: BehaviorSubject<Lov[]>;
  private wizardPromotionTypeList!: BehaviorSubject<Lov[]>;
  private mechanicTypeList!: BehaviorSubject<Lov[]>;
  private invoiceStatusList!: BehaviorSubject<Lov[]>;
  private phaseList!: BehaviorSubject<Phase[]>;
  private labelList!: BehaviorSubject<Labels[]>;
  private supplierList!: BehaviorSubject<Supplier[]>;
  private createdByList!: BehaviorSubject<Buyer[]>;
  private buyerList!: BehaviorSubject<Buyer[]>;
  private subTypeList!: BehaviorSubject<Lov[]>;
  private brandList!: BehaviorSubject<Brand[]>;
  private assignToList!: BehaviorSubject<Buyer[]>;
  private extractedByList!: BehaviorSubject<Buyer[]>;
  private submittedByList!: BehaviorSubject<Buyer[]>;
  private commentedByList!: BehaviorSubject<Buyer[]>;
  private shortdescriptionByList!: BehaviorSubject<Buyer[]>;
  private podList!: BehaviorSubject<Pod[]>;
  private subpodList!: BehaviorSubject<Subpod[]>;
  private departmentList!: BehaviorSubject<Department[]>;
  private categoryList!: BehaviorSubject<Category[]>;
  private subCategoryList!: BehaviorSubject<SubCategory[]>;
  private webshopList!: BehaviorSubject<Webshop[]>;
  private errorWarningTypeList!: BehaviorSubject<ErrorWarningType[]>;
  private proposalData!: BehaviorSubject<any>;
  public filteredGridData!: BehaviorSubject<any[]>;
  public filteredGridDataResult!: BehaviorSubject<number | null>;
  public stepperIndex!: BehaviorSubject<number>;
  public errorMessage!: BehaviorSubject<ErrorMsg[]>;
  public selectedPromoType!: BehaviorSubject<string>;
  public selectedPromoTypeName!: BehaviorSubject<string>;
  public proposalForm!: BehaviorSubject<any>;
  public reloadWizard: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private drawerDataList!: BehaviorSubject<any[]>;
  public showAuditList: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public previewSwitchOn: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public filterTriggerBh: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public showSummaryLoader: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public pageSizeCount: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  public pages: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  public options: any = { pageSize: promotionConstants.pageSize };
  public state1: any = { skip: 0, take: promotionConstants.pageSize };
  private actionNamesList: BehaviorSubject<ActionNames[]>;
  private promoMechanicType: BehaviorSubject<Lov[]>;
  private promoSubType: BehaviorSubject<Lov[]>;
  private rejectReasonList!: BehaviorSubject<Lov[]>;
  private _comments!: BehaviorSubject<any[]>;
  public dropTrigger: boolean = false;
  private inFlightRequests: Set<string> = new Set<string>();
  private statusCache: { [key: string]: Lov[] } = {};

  public dataStore: {
    promotion: any,
    fields: Lov[],
    status: Lov[],
    sfmStatus: Lov[],
    promotionType: Lov[],
    mechanicType: Lov[],
    promotionSubTypes: Lov[],
    promoMechanicTypes: Lov[];
    invoiceStatus: Lov[];
    subType: Lov[],
    phase: Phase[],
    label: Labels[],
    supplier: Supplier[],
    buyer: Buyer[],
    brand: Brand[],
    assignTo: Buyer[],
    extractedBy: Buyer[],
    submittedBy: Buyer[],
    commentedBy: Buyer[],
    createdBy: Buyer[],
    pod: Pod[],
    subpod: Subpod[],
    department: Department[],
    category: Category[],
    subCategory: SubCategory[],
    webshop: Webshop[],
    errorWarningType: ErrorWarningType[],
    supplierGridData: SupplierColumnValues[],
    filterGridData: any[];
    filterGridDataResult: number | null;
    wizardPromotionTypes: Lov[];
    errors: ErrorMsg[];
    drawerData: any[];
    actionNames: ActionNames[];
    rejectReasons: Lov[],
    reqCat: Lov[],
    src: Lov[],
    promoStatus: Lov[],
    cgCrName: Lov[],
    cgRequestSts: Lov[];
    cgRequestBy: Lov[];
  };

  constructor(
    private http: HttpClient,
    private authService: OcadoAuthService,
    private sharedService: SharedService,
    private router: Router,
    private summaryV2Service?: SummaryV2Service
  ) {
    super();
    this.masterDataBaseUrl = environment.masterDataBaseUrl;
    this.promotionBaseUrl = environment.promotionBaseUrl;
    this.productBaseUrl = environment.productBaseUrl;
    this.workFlowBaseUrl = environment.workFlowBaseUrl;
    this.dashboardBaseUrl = environment.dashboardBaseUrl;
    this.supplierBaseUrl = environment.supplierBaseUrl;
    this.authBaseUrl = environment.authBaseUrl;
    this.proposalBaseUrl = environment.proposalBaseUrl;
    this.uploadDownloadBaseUrl = environment.uploadDownloadBaseUrl;
    this.promotionData = new BehaviorSubject<any>({});
    this.proposalData = new BehaviorSubject<SupplierColumnValues[]>([]);
    this.fieldsList = new BehaviorSubject<Lov[]>([]);
    this.statusList = new BehaviorSubject<Lov[]>([]);
    this.sfmStatusList = new BehaviorSubject<Lov[]>([]);
    this.criteriaList = new BehaviorSubject<Lov[]>([]);
    this.cgRequestStatusList = new BehaviorSubject<Lov[]>([]);
    this.promotionTypeList = new BehaviorSubject<Lov[]>([]);
    this.wizardPromotionTypeList = new BehaviorSubject<Lov[]>([]);
    this.mechanicTypeList = new BehaviorSubject<Lov[]>([]);
    this.invoiceStatusList = new BehaviorSubject<Lov[]>([]);
    this.subTypeList = new BehaviorSubject<Lov[]>([]);
    this.promoMechanicType = new BehaviorSubject<Lov[]>([]);
    this.promoSubType = new BehaviorSubject<Lov[]>([]);
    this.phaseList = new BehaviorSubject<Phase[]>([]);
    this.labelList = new BehaviorSubject<Labels[]>([]);
    this.supplierList = new BehaviorSubject<Supplier[]>([]);
    this.createdByList = new BehaviorSubject<Buyer[]>([]);
    this.submittedByList = new BehaviorSubject<Buyer[]>([]);
    this.commentedByList = new BehaviorSubject<Buyer[]>([]);
    this.shortdescriptionByList = new BehaviorSubject<Buyer[]>([]);
    this.buyerList = new BehaviorSubject<Buyer[]>([]);
    this.brandList = new BehaviorSubject<Brand[]>([]);
    this.assignToList = new BehaviorSubject<Buyer[]>([]);
    this.extractedByList = new BehaviorSubject<Buyer[]>([]);
    this.departmentList = new BehaviorSubject<Department[]>([]);
    this.podList = new BehaviorSubject<Pod[]>([]);
    this.subpodList = new BehaviorSubject<Subpod[]>([]);
    this.categoryList = new BehaviorSubject<Category[]>([]);
    this.subCategoryList = new BehaviorSubject<SubCategory[]>([]);
    this.webshopList = new BehaviorSubject<Webshop[]>([]);
    this.errorWarningTypeList = new BehaviorSubject<ErrorWarningType[]>([]);
    this.filteredGridData = new BehaviorSubject<any[]>([]);
    this.filteredGridDataResult = new BehaviorSubject<number | null>(null);
    this.errorMessage = new BehaviorSubject<ErrorMsg[]>([]);
    this.drawerDataList = new BehaviorSubject<any[]>([]);
    this.actionNamesList = new BehaviorSubject<ActionNames[]>([]);
    this.rejectReasonList = new BehaviorSubject<Lov[]>([]);
    this._comments = new BehaviorSubject<any[]>([]);
    this.reqCatList = new BehaviorSubject<Lov[]>([]);
    this.srcList = new BehaviorSubject<Lov[]>([]);
    this.promoStatusList = new BehaviorSubject<Lov[]>([]);
    this.cgRequestByList = new BehaviorSubject<Lov[]>([]);
    this.dataStore = {
      promotion: {}, supplierGridData: [], filterGridData: [], fields: [], status: [], sfmStatus: [], promotionType: [], mechanicType: [], subType: [], phase: [], label: [], supplier: [], buyer: [], wizardPromotionTypes: [], brand: [], assignTo: [], createdBy: [], submittedBy: [], commentedBy: [], extractedBy: [], pod: [], department: [], subpod: [], category: [], subCategory: [], webshop: [], errorWarningType: [], errors: [], filterGridDataResult: null, drawerData: [], actionNames: [], promotionSubTypes: [], promoMechanicTypes: [], rejectReasons: [], invoiceStatus: [], reqCat: [], src: [], promoStatus: [], cgCrName: [], cgRequestSts: [], cgRequestBy: []
    };
    this.stepperIndex = new BehaviorSubject<number>(0);

    this.summaryGridHeaders = new BehaviorSubject<any[]>(this.authService.isStaff
      ? promotionConstants.buyerColumnsList
      : promotionConstants.supplierColumnsList);

    this.reorderCols = new BehaviorSubject<any[]>(promotionConstants.customerGroupReqColumnsList);

    this.selectedPromoType = new BehaviorSubject<string>('');
    this.selectedPromoTypeName = new BehaviorSubject<string>('');
    this.proposalForm = new BehaviorSubject<any>('');

  }
  public allViews: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  public viewsLoaded: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public selectedView: BehaviorSubject<any> = new BehaviorSubject({});
  public originalColumns = new BehaviorSubject<any[]>(this.authService.isStaff
    ? promotionConstants.buyerColumnsList
    : promotionConstants.supplierColumnsList);

  public reorderOGCols = new BehaviorSubject<any[]>(promotionConstants.customerGroupReqColumnsList);

  // dummyResponse = [
  //   {
  //     "search_id": 4,
  //     "search_name": "test",
  //     "is_default": "N",
  //     "search_criteria": "summary?q=eyJmaWx0ZXIiOlt7ImNvbmRpdGlvbiI6ImFuZCIsImZpZWxkIjoicHJvbW90aW9uX3R5cGUiLCJvcGVyYXRvciI6IkVxdWFsIiwidHlwZSI6InN0cmluZyIsInZhbHVlIjoiTXVsdCIsImRpc3BsYXlfZmllbGQiOiJQcm9tb3Rpb24gVHlwZSIsImRpc3BsYXlfdmFsdWUiOiJNdWx0aWJ1eSIsIm9wZXJhdG9yX2xvdl9jb2RlIjoiTE9WX0dST1VQX0ZJWEVEIn1dLCJzb3J0Ijp7ImZpZWxkIjpudWxsLCJkaXNwbGF5X2ZpZWxkIjoiIiwidHlwZSI6bnVsbH0sInBhZ2luYXRpb24iOnsicGFnZV9udW1iZXIiOjEsInBhZ2Vfc2l6ZSI6MzB9LCJyZXFDb3VudCI6dHJ1ZSwiY2hhbmdlX3Bvc3RfZXh0cmFjdGlvbiI6ZmFsc2V9"
  //   }
  // ];

  fetchView(forceRefresh = false) {
    if (!forceRefresh && this.viewsLoaded.value) {
      this.allViews.next(this.allViews.value);
      return;
    }
    const url = this.dashboardBaseUrl + 'view?screen_type=summary';
    this.http.get<any>(url).subscribe({
      next: data => {
        this.allViews.next(data.result);
        this.viewsLoaded.next(true);
      },
      error: () => {
        this.viewsLoaded.next(true);
      }
    });
  }

  saveView(payload: any) {
    const url = this.dashboardBaseUrl + 'view';
    return this.http.post<any>(url, payload).pipe(catchError(() => of({ result: {} as any, code: 'error' })));
  }

  deleteView(payload: any) {
    const url = this.dashboardBaseUrl + 'view/delete';
    return this.http.post<any>(url, payload).pipe(catchError(() => of({ result: {} as any, code: 'error' })));
  }

  savePromotion(promotion: any): Observable<any> {
    if (!environment.useLegacy && this.summaryV2Service) {
      const cleanEntity = PromotionV2Mapper.toPromotionV2(promotion);
      return this.summaryV2Service.createPromotion(cleanEntity).pipe(
        map((savedV2) => ({
          code: 200,
          status: true,
          result: [PromotionV2Mapper.toLegacyPromotion(savedV2)],
        })),
        catchError((err) => of({ result: {} as any, code: 'error', error: err }))
      );
    }
    if (promotion.promotion_type === 'SInv') {
      promotion.reward_amount = 0;
    }
    promotion.promotion_id = null;
    const reqData: any = {
      source: "PROMO_WIZARD",
      application_id: "1",
      from_status: "*",
      action: "Save",
      Object_type: "PRM",
      fully_filled_ind: true,
      page_size: 50,
      promotion_data: [ promotion ]
    };
    const url = this.workFlowBaseUrl + 'promotion';
    return this.http.post<any>(url, reqData).pipe(catchError(() => of({ result: {} as any, code: 'error' })));
  }

  validateMergePromotion(reqData: any): Observable<any> {
    const url = this.workFlowBaseUrl + 'promotion/merge-validations';
    return this.http.post<any>(url, reqData).pipe(catchError(() => of({ result: {} as any, code: 'error' })));
  }

  saveMergePromotion(reqData: any): Observable<any> {
    const url = this.workFlowBaseUrl + 'promotion/merge';
    return this.http.post<any>(url, reqData).pipe(catchError((data) => of({ ...data.error })));
  }
  unmergeProposal(req: any) {
    const url = this.workFlowBaseUrl + 'promotion/reject-unmerge';
    return this.http.post<any>(url, req).pipe(catchError((data) => of({ ...data.error })));
  }

  getPromotionById() {
    const url = this.promotionBaseUrl + 'promotion';
    this.http.get<APIResponse>(url).subscribe((data: APIResponse) => {
      this.dataStore.promotion = data.result;
      this.promotionData.next(Object.assign({}, this.dataStore).promotion);
    });
  }

  public fetchDownloadSfm(promotion_id: any): Observable<any> {
    const url = this.uploadDownloadBaseUrl + 'excel/download-promotion';
    return this.http.post<any>(url, promotion_id);
  }

  promoMarginCal(vat: number, costPrice: number, triggerFunding: number, promotionPrice: number,) {
    const result = +((+((((promotionPrice) / (1 + vat)) - (costPrice - triggerFunding)) / (promotionPrice)).toFixed(4) * 100));
    return !Number.isNaN(result) && Number.isFinite(result) && ![ 0.000, 0.00, 0.0, 0, null ].includes(promotionPrice) ? result : '0.00';
  }

  fetchFieldsList(lovReq: ReqFields, forceRefresh = false) {
    if (!forceRefresh && this.dataStore.fields && this.dataStore.fields.length > 0) {
      this.fieldsList.next(Object.assign({}, this.dataStore).fields);
      return;
    }
    const key = 'fields';
    if (this.inFlightRequests.has(key)) return;
    this.inFlightRequests.add(key);
    const url = this.masterDataBaseUrl + 'lov';
    this.http.post<APIResponse>(url, lovReq).subscribe({
      next: (data: APIResponse) => {
        this.inFlightRequests.delete(key);
        this.dataStore.fields = data.result;
        this.fieldsList.next(Object.assign({}, this.dataStore).fields);
      },
      error: () => {
        this.inFlightRequests.delete(key);
      }
    });
  }
  fetchStatusList(lovReq: ReqFields, forceRefresh = false) {
    const key = `status_${lovReq?.req_lov_id || ''}_${lovReq?.lov_depend_code || ''}`;
    if (!forceRefresh && this.statusCache[key] && this.statusCache[key].length > 0) {
      this.dataStore.status = this.statusCache[key];
      this.statusList.next(Object.assign([], this.dataStore.status));
      return;
    }
    if (this.inFlightRequests.has(key)) return;
    this.inFlightRequests.add(key);
    const url = this.masterDataBaseUrl + 'lov';
    this.http.post<APIResponse>(url, lovReq).subscribe({
      next: (data: APIResponse) => {
        this.inFlightRequests.delete(key);
        this.statusCache[key] = data.result;
        this.dataStore.status = data.result;
        this.statusList.next(Object.assign([], this.dataStore.status));
      },
      error: () => {
        this.inFlightRequests.delete(key);
      }
    });
  }
  fetchSfmStatusList(lovReq: ReqFields, forceRefresh = false) {
    if (!forceRefresh && this.dataStore.sfmStatus && this.dataStore.sfmStatus.length > 0) {
      this.sfmStatusList.next(Object.assign({}, this.dataStore).sfmStatus);
      return;
    }
    const key = 'sfmStatus';
    if (this.inFlightRequests.has(key)) return;
    this.inFlightRequests.add(key);
    const url = this.masterDataBaseUrl + 'lov';
    this.http.post<APIResponse>(url, lovReq).subscribe({
      next: (data: APIResponse) => {
        this.inFlightRequests.delete(key);
        this.dataStore.sfmStatus = data.result;
        this.sfmStatusList.next(Object.assign({}, this.dataStore).sfmStatus);
      },
      error: () => {
        this.inFlightRequests.delete(key);
      }
    });
  }
  fetchTermsConditionPdf() {
    const url = this.uploadDownloadBaseUrl + 'excel/download-terms-condition';
    return this.http.get<APIResponse>(url);
  }
  fetchPromotionTypeList(lovReq: ReqFields, forceRefresh = false) {
    if (!forceRefresh && this.dataStore.promotionType && this.dataStore.promotionType.length > 0) {
      this.promotionTypeList.next(Object.assign({}, this.dataStore).promotionType);
      return;
    }
    const key = 'promotionType';
    if (this.inFlightRequests.has(key)) return;
    this.inFlightRequests.add(key);
    const url = this.masterDataBaseUrl + 'lov';
    this.http.post<APIResponse>(url, lovReq).subscribe({
      next: (data: APIResponse) => {
        this.inFlightRequests.delete(key);
        this.dataStore.promotionType = data.result;
        this.promotionTypeList.next(Object.assign({}, this.dataStore).promotionType);
      },
      error: () => {
        this.inFlightRequests.delete(key);
      }
    });
  }
  fetchMechanicTypeList(lovReq: ReqFields, forceRefresh = false) {
    if (!forceRefresh && this.dataStore.mechanicType && this.dataStore.mechanicType.length > 0) {
      this.mechanicTypeList.next(Object.assign({}, this.dataStore).mechanicType);
      return;
    }
    const key = 'mechanicType';
    if (this.inFlightRequests.has(key)) return;
    this.inFlightRequests.add(key);
    const url = this.masterDataBaseUrl + 'lov';
    this.http.post<APIResponse>(url, lovReq).subscribe({
      next: (data: APIResponse) => {
        this.inFlightRequests.delete(key);
        this.dataStore.mechanicType = data.result;
        this.mechanicTypeList.next(Object.assign({}, this.dataStore).mechanicType);
      },
      error: () => {
        this.inFlightRequests.delete(key);
      }
    });
  }
  fetchInvoiceStatusList(lovReq: ReqFields, forceRefresh = false) {
    if (!forceRefresh && this.dataStore.invoiceStatus && this.dataStore.invoiceStatus.length > 0) {
      this.invoiceStatusList.next(Object.assign({}, this.dataStore).invoiceStatus);
      return;
    }
    const key = 'invoiceStatus';
    if (this.inFlightRequests.has(key)) return;
    this.inFlightRequests.add(key);
    const url = this.masterDataBaseUrl + 'lov';
    this.http.post<APIResponse>(url, lovReq).subscribe({
      next: (data: APIResponse) => {
        this.inFlightRequests.delete(key);
        this.dataStore.invoiceStatus = data.result;
        this.invoiceStatusList.next(Object.assign({}, this.dataStore).invoiceStatus);
      },
      error: () => {
        this.inFlightRequests.delete(key);
      }
    });
  }
  fetchSubTypeList(lovReq: ReqFields, forceRefresh = false) {
    if (!forceRefresh && this.dataStore.subType && this.dataStore.subType.length > 0) {
      this.subTypeList.next(Object.assign({}, this.dataStore).subType);
      return;
    }
    const key = 'subType';
    if (this.inFlightRequests.has(key)) return;
    this.inFlightRequests.add(key);
    const url = this.masterDataBaseUrl + 'lov';
    this.http.post<APIResponse>(url, lovReq).subscribe({
      next: (data: APIResponse) => {
        this.inFlightRequests.delete(key);
        this.dataStore.subType = data.result;
        this.subTypeList.next(Object.assign({}, this.dataStore).subType);
      },
      error: () => {
        this.inFlightRequests.delete(key);
      }
    });
  }
  fetchPhaseList(forceRefresh = false) {
    if (!forceRefresh && this.dataStore.phase && this.dataStore.phase.length > 0) {
      this.phaseList.next(Object.assign({}, this.dataStore).phase);
      return;
    }
    const key = 'phase';
    if (this.inFlightRequests.has(key)) return;
    this.inFlightRequests.add(key);
    const url = this.masterDataBaseUrl + 'promotion-phase?type=filter';
    this.http.get<APIResponse>(url).subscribe({
      next: (data: APIResponse) => {
        this.inFlightRequests.delete(key);
        this.dataStore.phase = data.result.map((value: any) => ({ ...value, promotion_end_date: value.promotion_end_date.split('T')[ 0 ] + 'T00:00:00.000Z' }));
        this.phaseList.next(Object.assign({}, this.dataStore).phase);
      },
      error: () => {
        this.inFlightRequests.delete(key);
      }
    });
  }
  fetchLabelList(forceRefresh = false) {
    if (!forceRefresh && this.dataStore.label && this.dataStore.label.length > 0) {
      this.labelList.next(Object.assign({}, this.dataStore).label);
      return;
    }
    const key = 'label';
    if (this.inFlightRequests.has(key)) return;
    this.inFlightRequests.add(key);
    const url = this.masterDataBaseUrl + 'label?&from_source=summary&include_deleted=Y';
    this.http.get<APIResponse>(url).subscribe({
      next: (data: APIResponse) => {
        this.inFlightRequests.delete(key);
        this.dataStore.label = data.result;
        this.labelList.next(Object.assign({}, this.dataStore).label);
      },
      error: () => {
        this.inFlightRequests.delete(key);
      }
    });
  }

  fetchLabels(searchText: string) {
    const url = this.masterDataBaseUrl + 'label?label_description=' + searchText + '&from_source=summary&include_deleted=N';
    return this.http.get<APIResponse>(url).pipe(map(data => data.result)).pipe(catchError(() => of([])));
  }

  fetchSupplierList(forceRefresh = false) {
    if (!forceRefresh && this.dataStore.supplier && this.dataStore.supplier.length > 0) {
      this.supplierList.next(Object.assign({}, this.dataStore).supplier);
      return;
    }
    const key = 'supplier';
    if (this.inFlightRequests.has(key)) return;
    this.inFlightRequests.add(key);
    const url = this.supplierBaseUrl + 'supplier';
    this.http.get<APIResponse>(url).subscribe({
      next: (data: APIResponse) => {
        this.inFlightRequests.delete(key);
        this.dataStore.supplier = data.result;
        this.supplierList.next(Object.assign({}, this.dataStore).supplier);
      },
      error: () => {
        this.inFlightRequests.delete(key);
      }
    });
  }
  fetchBuyerList(params: any, forceRefresh = false) {
    if (!forceRefresh && this.dataStore.buyer && this.dataStore.buyer.length > 0) {
      this.buyerList.next(Object.assign({}, this.dataStore).buyer);
      return;
    }
    const key = 'buyer_' + (params || '');
    if (this.inFlightRequests.has(key)) return;
    this.inFlightRequests.add(key);
    const url = this.authBaseUrl + 'authorised-user/buyer-name' + params;
    this.http.get<APIResponse>(url).subscribe({
      next: (data: APIResponse) => {
        this.inFlightRequests.delete(key);
        this.dataStore.buyer = data.result;
        this.buyerList.next(Object.assign({}, this.dataStore).buyer);
      },
      error: () => {
        this.inFlightRequests.delete(key);
      }
    });
  }
  fetchBrandList(params: any) {
    const url = this.productBaseUrl + 'product/brand' + params;
    this.http.get<APIResponse>(url).subscribe((data: APIResponse) => {
      this.dataStore.brand = data.result;
      this.brandList.next(Object.assign({}, this.dataStore).brand);
    });
  }
  fetchAssignToList(params: any) {
    const url = this.authBaseUrl + 'authorised-user/get-users-for-filter?type=' + params;
    this.http.get<APIResponse>(url).subscribe((data: APIResponse) => {
      if (params === 'assigned_to') {
        this.dataStore.assignTo = data.result;
        this.assignToList.next(Object.assign({}, this.dataStore).assignTo);
      } else if (params === 'extracted_by') {
        this.dataStore.extractedBy = data.result;
        this.extractedByList.next(Object.assign({}, this.dataStore).extractedBy);
      }
      else if (params === 'Created_By') {
        this.dataStore.cgRequestBy = data.result;
        this.cgRequestByList.next(Object.assign({}, this.dataStore).cgRequestBy);
      }
      // else if (params === 'Created_By') {
      //   this.dataStore.createdBy = data.result;
      //   this.createdByList.next(Object.assign({}, this.dataStore).createdBy);
      // }
      // else if (params === 'Submitted_By') {
      //   this.dataStore.submittedBy = data.result;
      //   this.submittedByList.next(Object.assign({}, this.dataStore).submittedBy);
      // }
    });
  }
  fetchDepartmentList(params: any) {
    const url = this.productBaseUrl + 'product/cat-subcat-dep?type=' + params;
    this.http.get<APIResponse>(url).subscribe((data: APIResponse) => {
      if (params === 'Dept') {
        this.dataStore.department = data.result;
        this.departmentList.next(Object.assign({}, this.dataStore).department);
      } else if (params === 'Cat') {
        this.dataStore.category = data.result;
        this.categoryList.next(Object.assign({}, this.dataStore).category);
      } else if (params === 'SubCat') {
        this.dataStore.subCategory = data.result;
        this.subCategoryList.next(Object.assign({}, this.dataStore).subCategory);
      } else if (params === 'Pod') {
        this.dataStore.pod = data.result;
        this.podList.next(Object.assign({}, this.dataStore).pod);
      } else if (params === 'SubPod') {
        this.dataStore.subpod = data.result;
        this.subpodList.next(Object.assign({}, this.dataStore).subpod);
      }
    });
  }
  getSummaryGridData() {
    const url = this.dashboardBaseUrl + 'summary';
    this.http.post<APIResponse>(url, '').subscribe((data: APIResponse) => {
      this.dataStore.supplierGridData = data.result;
      this.proposalData.next(Object.assign({}, this.dataStore).supplierGridData);
    });
  }

  public execute(filterData: any) {
    this.dataStore.filterGridData = [];
    this.dataStore.filterGridDataResult = 0;
    this.filteredGridData.next(Object.assign({}, this.dataStore).filterGridData);
    this.filteredGridDataResult.next(Object.assign({}, this.dataStore).filterGridDataResult);
    super.next({});
    return this.fetchFilterSummaryData(filterData).pipe(
      catchError(() => {
        this.dataStore.filterGridData = [];
        this.dataStore.filterGridDataResult = 0;
        this.filteredGridData.next(Object.assign({}, this.dataStore).filterGridData);
        this.filteredGridDataResult.next(Object.assign({}, this.dataStore).filterGridDataResult);
        this.showSummaryLoader.next(false);
        super.next({});
        return of();
      })
    );

  }

  fetchFilterSummaryData(filterData: any): Observable<any> {
    const url = this.dashboardBaseUrl + 'summary';
    const fieldsToUpdate = [ "product_no", "promotion_id", "proposal_id", "sfm_promo_id" ];
    filterData.filter
      .filter((data: any) => fieldsToUpdate.includes(data.field))
      .forEach((data: any) => data.value = data.display_value);
    filterData.filter.length > 0 ? filterData.filter[ 0 ].condition = 'and' : filterData;
    return this.http.post<APIResponse>(url, filterData).pipe(map((response: any) => (<any> {
      result: response.result,
      count: response.pagination.total,
      size: response.pagination.max,
      pages: response.pagination.pages,
      // here we are returning the data as Object of result and count
    })))
      .pipe((data: any) => data);
  }

  chipsFun(form: any, filterText: string, filterSelected: number[], chipListData: any[], data: Filtration, filterErrorSelected?: number[], filterWarningSelected?: number[], filterPESelected?: number[], filterDraftSelected?: number[], filterResSelected?: number[]) {
    filterText = 'Filter';
    filterSelected = [];
    filterErrorSelected = [];
    filterWarningSelected = [];
    filterPESelected = [];
    filterDraftSelected = [];
    filterResSelected = [];
    const count = form.filter.length as number;
    if (count > 0) {
      filterText = filterText + ' | ' + count;
      filterSelected = [ 0 ];
    }
    chipListData = [];
    form.filter.forEach((data: any) => {
      // if (data.field !== 'errors' && data.field !== 'warnings' && data.field !== 'pe_warning_indicator') {
      chipListData.push({ field: data.display_field + ' ' + data.operator + ' ', value: data.display_value + ' ', operator: data.operator, orginalField: data.field });
      // }
    });
    if (form.sort.field !== null) {
      chipListData.push({ field: 'Sorted by ', value: form.sort.display_field + ' ', operator: '', orginalField: '' });
    }
    const errorTrigger = form.filter.findIndex((value: any) => (value.field === 'errors' && value.operator === 'Equal' && value.value === promotionConstants.Dialog_Messages.yes) || (value.field === 'errors' && value.operator === 'Not Equal' && value.value === promotionConstants.Dialog_Messages.no));
    filterErrorSelected = errorTrigger >= 0 ? [ 0 ] : [];

    const draftTrigger = form.filter.findIndex((value: any) => (value.field === 'cg_status' && value.operator === 'Equal' && value.value === "CGR_Draft") || (value.field === 'cg_status' && value.operator === 'In' && value.value === "CGR_Draft") || (value.field === 'cg_status' && value.operator === 'Not In' && value.value === "CGR_Draft"));
    filterDraftSelected = draftTrigger >= 0 ? [ 0 ] : [];

    const resTrigger = form.filter.findIndex((value: any) => (value.field === 'cg_status' && value.operator === 'Equal' && value.value === "CGR_Response_Receive") || (value.field === 'cg_status' && value.operator === 'In' && value.value === "CGR_Response_Receive") || (value.field === 'cg_status' && value.operator === 'Not In' && value.value === "CGR_Response_Receive"));
    filterResSelected = resTrigger >= 0 ? [ 0 ] : [];

    const warningTrigger = form.filter.findIndex((value: any) => (value.field === 'warnings' && value.operator === 'Equal' && value.value === promotionConstants.Dialog_Messages.yes) || (value.field === 'errors' && value.operator === 'Not Equal' && value.value === promotionConstants.Dialog_Messages.no));
    filterWarningSelected = warningTrigger >= 0 ? [ 0 ] : [];

    const supplierPETrigger = form.filter.findIndex((value: any) => (value.field === 'pe_supplier_warning_indicator' && value.operator === 'Equal' && value.value === promotionConstants.Dialog_Messages.yes) || (value.field === 'pe_supplier_warning_indicator' && value.operator === 'Not Equal' && value.value === promotionConstants.Dialog_Messages.no));

    const pETrigger = form.filter.findIndex((value: any) => (value.field === 'pe_warning_indicator' && value.operator === 'Equal' && value.value === promotionConstants.Dialog_Messages.yes) || (value.field === 'pe_warning_indicator' && value.operator === 'Not Equal' && value.value === promotionConstants.Dialog_Messages.no));

    const statusTrigger = form.filter.findIndex((value: any) => JSON.stringify(value.value) === JSON.stringify(promotionConstants.peFilter.value) && value.field === promotionConstants.peFilter.field && value.condition === promotionConstants.peFilter.condition && value.display_field === promotionConstants.peFilter.display_field && value.display_value === promotionConstants.peFilter.display_value && value.operator === promotionConstants.peFilter.operator && value.operator_lov_code === promotionConstants.peFilter.operator_lov_code && value.type === promotionConstants.peFilter.type);
    if (this.authService.isStaff) {
      filterPESelected = (pETrigger >= 0 && statusTrigger >= 0) ? [ 0 ] : [];
    } else {
      filterPESelected = (supplierPETrigger >= 0) ? [ 0 ] : [];
    }
    data = form;
    return { filterText: filterText, filterSelected: filterSelected, filterErrorSelected: filterErrorSelected, filterWarningSelected: filterWarningSelected, filterPESelected: filterPESelected, chipListData: chipListData, data: data, filterDraftSelected: filterDraftSelected, filterResSelected: filterResSelected };
  }

  splitFunction(value: string, operator: string) {
    const chipValue = value.split(',').length > 1 && [ 'In', 'Not In' ].includes(operator) ? { value: value.split(',')[ 0 ], meta: '   + ' + (value.split(',').length - 1) + ' more   ' } : { value: value };
    return chipValue;

  }

  createFormGroup(data?: Filtration): FormGroup<filtrationFormGroup> {
    return new FormGroup<filtrationFormGroup>({
      filter: this.createFilterFormGroup(data?.filter || []),
      sort: this.createSortFormGroup(data?.sort as Sort),
      pagination: this.createPaginationFormGroup(data?.pagination as Pagination),
      reqCount: new FormControl(data?.reqCount ? data?.reqCount : false, { nonNullable: true }),
      change_post_extraction: new FormControl(data?.change_post_extraction ? data?.change_post_extraction : false, { nonNullable: true }),
    });
  }
  createFilterFormGroup(value: Filter[]): FormArray<FormGroup<FilterFormGroup>> {
    const fromArray = value.map(data => new FormGroup<FilterFormGroup>({
      condition: new FormControl(data?.condition ? data?.condition : '', { nonNullable: true }),
      field: new FormControl(data?.field ? data?.field : '', { nonNullable: true }),
      operator: new FormControl(data?.operator ? data?.operator : '', { nonNullable: true }),
      type: new FormControl(data?.type ? data?.type : '', { nonNullable: true }),
      value: new FormControl(data?.value ? data?.value : '', { nonNullable: true, validators: [ Validators.required ] }),
      display_field: new FormControl(data?.display_field ? data?.display_field : '', { nonNullable: true }),
      display_value: new FormControl(data?.display_value ? data?.display_value : '', { nonNullable: true }),
      operator_lov_code: new FormControl(data?.operator_lov_code ? data?.operator_lov_code : '', { nonNullable: true }),
    }, {
      validators: [ FilterValidators.noWhiteSpace, FilterValidators.noBetweenSpace, FilterValidators.requiredValue ]
    }));
    return new FormArray<FormGroup<FilterFormGroup>>(fromArray);
  }
  createSortFormGroup(data: Sort) {
    return new FormGroup<SortFormGroup>({
      field: new FormControl(data?.field ? data?.field : null, { nonNullable: true }),
      display_field: new FormControl(data?.display_field ? data?.display_field : '', { nonNullable: true }),
      type: new FormControl(data?.type ? data?.type : null, { nonNullable: true }),
    });
  }
  createPaginationFormGroup(data: Pagination) {
    return new FormGroup<PaginationFormGroup>({
      page_number: new FormControl(data?.page_number ? data?.page_number : null, { nonNullable: true }),
      page_size: new FormControl(data?.page_size ? data?.page_size : null, { nonNullable: true }),
    });
  }

  createFilterDefaultFormGroup(data: Filter): FormGroup<FilterFormGroup> {
    return new FormGroup<FilterFormGroup>({
      condition: new FormControl(data?.condition ? data?.condition : '', { nonNullable: true }),
      field: new FormControl(data?.field ? data?.field : '', { nonNullable: true }),
      operator: new FormControl(data?.operator ? data?.operator : '', { nonNullable: true }),
      type: new FormControl(data?.type ? data?.type : '', { nonNullable: true }),
      value: new FormControl(data?.value ? data?.value : '', { nonNullable: true, validators: [ Validators.required ] }),
      display_field: new FormControl(data?.display_field ? data?.display_field : '', { nonNullable: true }),
      display_value: new FormControl(data?.display_value ? data?.display_value : '', { nonNullable: true }),
      operator_lov_code: new FormControl(data?.operator_lov_code ? data?.operator_lov_code : '', { nonNullable: true }),
    }, {
      validators: [ FilterValidators.noWhiteSpace, FilterValidators.noBetweenSpace, FilterValidators.requiredValue ]
    });
  }

  fetchPromotionType(lovReq: LovReq) {
    const url = this.masterDataBaseUrl + 'lov';
    this.http.post<APIResponse>(url, lovReq).subscribe((data: APIResponse) => {
      this.dataStore.wizardPromotionTypes = data.result;
      this.wizardPromotionTypeList.next(Object.assign({}, this.dataStore).wizardPromotionTypes);
    });
  }

  fetchErrorMessage(errorBody: any) {
    const url = this.dashboardBaseUrl + 'summary/error-message';
    this.http.post<APIResponse>(url, errorBody).subscribe((data: APIResponse) => {
      this.dataStore.errors = data.result;
      this.errorMessage.next(Object.assign({}, this.dataStore).errors);
    });
  }
  fetchPromotionSubType(lovReq: LovReq) {
    const url = this.masterDataBaseUrl + 'lov';
    this.http.post<APIResponse>(url, lovReq).subscribe((data: APIResponse) => {
      this.dataStore.promotionSubTypes = data.result;
      this.promoSubType.next(Object.assign({}, this.dataStore).promotionSubTypes);
    });
  }

  fetchMechanicType(lovReq: LovReq) {
    const url = this.masterDataBaseUrl + 'lov';
    this.http.post<APIResponse>(url, lovReq).subscribe((data: APIResponse) => {
      this.dataStore.promoMechanicTypes = data.result;
      this.promoMechanicType.next(Object.assign({}, this.dataStore).promoMechanicTypes);
    });
  }
  fetchWebshop(lovReq: LovReq) {
    const url = this.masterDataBaseUrl + 'lov';
    this.http.post<APIResponse>(url, lovReq).subscribe((data: APIResponse) => {
      this.dataStore.webshop = data.result;
      this.webshopList.next(Object.assign({}, this.dataStore).webshop);
    });
  }
  fetchErrorWarningType(lovReq: LovReq) {
    const url = this.masterDataBaseUrl + 'lov';
    this.http.post<APIResponse>(url, lovReq).subscribe((data: APIResponse) => {
      this.dataStore.errorWarningType = data.result;
      this.errorWarningTypeList.next(Object.assign({}, this.dataStore).errorWarningType);
    });
  }
  saveProposal(proposal: any): Observable<any> {
    if (!environment.useLegacy && this.summaryV2Service) {
      const cleanEntity = ProposalV2Mapper.toProposalV2(proposal);
      return this.summaryV2Service.createProposal(cleanEntity).pipe(
        map((savedV2) => ({
          code: 200,
          status: true,
          result: [ProposalV2Mapper.toLegacyProposal(savedV2)],
        })),
        catchError((err) => of({ result: {} as Proposal, code: 'error', error: err }))
      );
    }
    if (proposal.promotion_type === 'SInv') {
      proposal.reward_amount = 0;
    }
    const reqData: any = {
      source: "PROMO_WIZARD",
      application_id: "1",
      from_status: "*",
      action: "Save",
      Object_type: "PRP",
      fully_filled_ind: true,
      page_size: 50,
      proposal_data: [ proposal ]
    };
    const url = this.workFlowBaseUrl + 'proposal';
    return this.http.post<APIResponse>(url, reqData).pipe(catchError(() => of({ result: {} as Proposal, code: 'error' })));
  }

  saveProposalData(proposal: any, fromStatus: string, action: string, fullyFilledInd: boolean = true, entity_type = 'PRP', peValidationEndpoint: boolean = false, PageSize?: number): Observable<any> {
    if (!environment.useLegacy && this.summaryV2Service && Array.isArray(proposal) && proposal.length > 0) {
      if (entity_type === 'PRM' && this.summaryV2Service.canHandlePromotionAction(action)) {
        return this.summaryV2Service.handlePromotionAction(proposal, action as PromotionAction);
      }
      if (entity_type === 'PRP' && this.summaryV2Service.canHandleProposalAction(action)) {
        return this.summaryV2Service.handleProposalAction(proposal, action as ProposalAction, peValidationEndpoint);
      }
    }
    const key = entity_type === 'PRP' ? 'proposal_data' : 'promotion_data';
    const reqData: any = {
      source: "SUMMARY",
      application_id: "1",
      from_status: fromStatus,
      action: action,
      Object_type: entity_type,
      page_size: PageSize || 50,
      fully_filled_ind: !fullyFilledInd ? fullyFilledInd : true,
      [ key ]: [ ...proposal ]
    };
    let url = '';
    if (entity_type === 'PRP') {
      url = this.workFlowBaseUrl + 'proposal';
    } else {
      url = this.workFlowBaseUrl + 'promotion';
    }
    if (peValidationEndpoint) url += '/pe-validation';
    return this.http.post<APIResponse>(url, reqData).pipe(
      tap((data) => data.code === 200 ? proposal.forEach((e: any) => this.sharedService.resetSessionStorageSearch(e.proposal_id)) : null),
      catchError((error) => of({ result: {} as Proposal, code: 'error', status: error?.status, error: error?.error?.error || error?.message }))
    );
  }

  savePromotionDatafromSummary(promotion: any, fromStatus: string, action: string, fullyFilledInd: boolean = true): Observable<any> {
    if (!environment.useLegacy && this.summaryV2Service && Array.isArray(promotion) && promotion.length > 0) {
      if (this.summaryV2Service.canHandlePromotionAction(action)) {
        return this.summaryV2Service.handlePromotionAction(promotion, action as PromotionAction);
      }
    }

    promotion.promotion_id = null;
    const reqData: any = {
      source: "SUMMARY",
      application_id: "1",
      from_status: fromStatus,
      action: action,
      Object_type: "PRM",
      fully_filled_ind: !fullyFilledInd ? fullyFilledInd : true,
      page_size: 50,
      promotion_data: [ ...promotion ]
    };
    const url = this.workFlowBaseUrl + 'promotion';
    return this.http.post<any>(url, reqData).pipe(tap((data) => { console.log(data, "summary save"), data.code === 200 ? promotion.forEach((e: any) => this.sharedService.resetSessionStorageSearch(e.promotion_id)) : null; }), catchError((error) => {
      return of({ code: error?.status || 'error', error: error?.error?.error || error?.message, result: [] } as any);
    }));
  }

  getAllWorkFlowAction() {
    const url = this.masterDataBaseUrl + 'lov/all-workflow-actions';
    this.http.get<APIResponse>(url).subscribe((data: APIResponse) => {
      this.dataStore.actionNames = data.result;
      this.actionNamesList.next(Object.assign({}, this.dataStore).actionNames);
    });
  }

  public fetchExcelTemplate(entity_type: any): Observable<any> {
    const url = this.uploadDownloadBaseUrl + 'excel/download';
    return this.http.post<any>(url, entity_type);
  }

  fetchRejectReason(lovReq: LovReq) {
    const url = this.masterDataBaseUrl + 'lov';
    this.http.post<APIResponse>(url, lovReq).subscribe((data: APIResponse) => {
      this.dataStore.rejectReasons = data.result;
      this.rejectReasonList.next(Object.assign({}, this.dataStore).rejectReasons);
    });
  }

  addComment(newComment: any) {
    const url = `${this.dashboardBaseUrl}/comment`;
    return this.http.post<APIResponse>(url, newComment).pipe(
      map((data) => {
        if (data.status) {
          this._comments.next([ data.result?.data, ... this._comments.value ]);
        }
      })).pipe(catchError(() => of({} as Proposal)));
  }

  systemSettingProposal(payload: any) {
    const url = this.masterDataBaseUrl + 'system-setting';
    return this.http.post<APIResponse>(url, payload).pipe(catchError(() => of({ result: null })));
  }

  fetchSupplierListByName(searchValue: string) {
    const url = this.supplierBaseUrl + 'supplier?name=' + searchValue;
    return this.http.get<APIResponse>(url);
  }

  fetchTypeAheadFieldsList(searchField: string, searchValue: string) {
    const fieldMap: any = {
      'department': { field: 'Dept', url: `${this.productBaseUrl}product/cat-subcat-dep?type=`, id: 'department_no', value: 'department_name' },
      'Category': { field: 'Cat', url: `${this.productBaseUrl}product/cat-subcat-dep?type=`, id: 'category_no', value: 'category_name' },
      'subcategory': { field: 'SubCat', url: `${this.productBaseUrl}product/cat-subcat-dep?type=`, id: 'subcategory_no', value: 'subcategory_name' },
      'pod': { field: 'Pod', url: `${this.productBaseUrl}product/cat-subcat-dep?type=`, id: 'pod_no', value: 'pod_name' },
      'subpod': { field: 'SubPod', url: `${this.productBaseUrl}product/cat-subcat-dep?type=`, id: 'sub_pod_no', value: 'sub_pod_name' },
      'brand_name': { field: 'UK_OCADO', url: `${this.productBaseUrl}product/brand?webshop=`, id: 'brand_id', value: 'brand_name' },
      'updated_by': { field: 'created_by', url: `${this.authBaseUrl}authorised-user/get-users-for-filter?type=`, id: 'user_id', value: 'user_name' },
      'commented_by': { field: 'created_by', url: `${this.authBaseUrl}authorised-user/get-users-for-filter?type=`, id: 'user_id', value: 'user_name' },
      'created_by': { field: 'created_by', url: `${this.authBaseUrl}authorised-user/get-users-for-filter?type=`, id: 'user_id', value: 'user_name' },
      'submitted_by': { field: 'submitted_by', url: `${this.authBaseUrl}authorised-user/get-users-for-filter?type=`, id: 'user_id', value: 'user_name' },
      'assigned_to': { field: 'assigned_to', url: `${this.authBaseUrl}authorised-user/get-users-for-filter?type=`, id: 'user_id', value: 'user_name' },
      'buyer_id': {
        field: 'UK_OCADO', url: `${this.authBaseUrl}authorised-user/buyer-name?banner_number=`, id: 'ocado_user_name', value: 'user_name'
      },
      'ocado_contact': { field: 'UK_OCADO', url: `${this.authBaseUrl}authorised-user/buyer-name?banner_number=`, id: 'ocado_user_name', value: 'user_name' },
      'labels': { field: '', url: `${this.masterDataBaseUrl}label/?label_description=`, id: 'label_id', value: 'label_description' },
    };
    const url = fieldMap[ searchField ].url + (searchField === 'labels' ? (searchValue + '&from_source=Summery&include_deleted=Y') : (fieldMap[ searchField ].field + '&name=' + searchValue));

    let modifiedData = { result: [] };
    return this.http.get<APIResponse>(url).pipe(
      map((data => {
        modifiedData.result = data.result.map((val: any) => ({
          supplier_no: val[ fieldMap[ searchField ].id ],
          supplier_name: val[ fieldMap[ searchField ].value ]
        }));
        return modifiedData;
      })));
  }

  fetchReqcategory(lovReq: ReqFields) {
    const url = this.masterDataBaseUrl + 'lov';
    this.http.post<APIResponse>(url, lovReq).subscribe((data: APIResponse) => {
      this.dataStore.reqCat = data.result;
      this.reqCatList.next(Object.assign({}, this.dataStore).reqCat);
    });
  }


  fetchSrcList(lovReq: ReqFields) {
    const url = this.masterDataBaseUrl + 'lov';
    this.http.post<APIResponse>(url, lovReq).subscribe((data: APIResponse) => {
      this.dataStore.src = data.result;
      this.srcList.next(Object.assign({}, this.dataStore).src);
    });

  }

  fetchpromoStatusList(lovReq: ReqFields) {
    const url = this.masterDataBaseUrl + 'lov';
    this.http.post<APIResponse>(url, lovReq).subscribe((data: APIResponse) => {
      this.dataStore.promoStatus = data.result;
      this.promoStatusList.next(Object.assign({}, this.dataStore).promoStatus);
    });
  }

  get promoStatus() {
    return this.promoStatusList;
  }

  fetchCgCriteriaList(lovReq: ReqFields) {
    const url = this.masterDataBaseUrl + 'lov';
    this.http.post<APIResponse>(url, lovReq).subscribe((data: APIResponse) => {
      this.dataStore.cgCrName = data.result;
      this.criteriaList.next(Object.assign({}, this.dataStore).cgCrName);
    });
  }

  get cgCriteria() {
    return this.criteriaList;
  }


  fetchCgRequestStatusList(lovReq: ReqFields) {
    const url = this.masterDataBaseUrl + 'lov';
    this.http.post<APIResponse>(url, lovReq).subscribe((data: APIResponse) => {
      this.dataStore.cgRequestSts = data.result;
      this.cgRequestStatusList.next(Object.assign({}, this.dataStore).cgRequestSts);
    });
  }

  get cgRequestStatus() {
    return this.cgRequestStatusList;
  }


  get requestCategory() {
    return this.reqCatList;
  }

  get sourceList() {
    return this.srcList;
  }


  get promotion() {
    return this.promotionData;
  }

  get proposalGridData() {
    return this.proposalData;
  }

  get filteredSummaryGridData() {
    return this.filteredGridData;
  }
  get filteredSummaryGridDataResult() {
    return this.filteredGridDataResult;
  }

  get fields() {
    return this.fieldsList;
  }

  get status() {
    return this.statusList;
  }
  get sfmStatus() {
    return this.sfmStatusList;
  }
  get promotionType() {
    return this.promotionTypeList;
  }
  get mechanicType() {
    return this.mechanicTypeList;
  }

  get getInvoiceStatus() {
    return this.invoiceStatusList;
  }
  get subType() {
    return this.subTypeList;
  }
  get phase() {
    return this.phaseList;
  }
  get label() {
    return this.labelList;
  }
  get supplier() {
    return this.supplierList;
  }
  get createdBy() {
    return this.createdByList;
  }
  get buyer() {
    return this.buyerList;
  }
  get brand() {
    return this.brandList;
  }
  get assignTo() {
    return this.assignToList;
  }
  get extractedBy() {
    return this.extractedByList;
  }
  get submittedBy() {
    return this.submittedByList;
  }
  get commentedBy() {
    return this.commentedByList;
  }
  get shortdesBy() {
    return this.shortdescriptionByList;
  }
  get pod() {
    return this.podList;
  }
  get subpod() {
    return this.subpodList;
  }
  get department() {
    return this.departmentList;
  }
  get category() {
    return this.categoryList;
  }
  get subCategory() {
    return this.subCategoryList;
  }
  get webshop() {
    return this.webshopList;
  }
  get errorWarning() {
    return this.errorWarningTypeList;
  }
  get wizardPromotionTypes() {
    return this.wizardPromotionTypeList;
  }

  get errorMsg() {
    return this.errorMessage;
  }

  get getActionNames() {
    return this.actionNamesList;
  }

  get getPromoMechType() {
    return this.promoMechanicType;
  }

  get getPromoSubType() {
    return this.promoSubType;
  }

  get rejectReasons() {
    return this.rejectReasonList;
  }

  get comments() {
    return this._comments;
  }
}
